export default "__VITE_ASSET__CSeB3RB7__"